import { supabase } from "@/lib/supabase/client";
import { requireUserId } from "@/features/identity/api/session";
import { MEDIA, MEDIA_BUCKET, MEDIA_EXT } from "@/features/identity/constants/media";

const storage = () => supabase.storage.from(MEDIA_BUCKET);

export async function uploadMedia(kind, file) {
  const uid = await requireUserId();
  const path = `${uid}/${MEDIA[kind].folder}/${Date.now()}.${MEDIA_EXT[file.type]}`;
  const { error } = await storage().upload(path, file, { contentType: file.type, upsert: false, cacheControl: "3600" });
  if (error) throw error;
  return { path, url: storage().getPublicUrl(path).data.publicUrl };
}

// Uploads a deterministic object under the user's own prefix unless it already exists.
export async function ensureOwnObject(relPath, makeBlob, contentType) {
  const uid = await requireUserId();
  const path = `${uid}/${relPath}`;
  const url = storage().getPublicUrl(path).data.publicUrl;
  const head = await fetch(url, { method: "HEAD", cache: "no-store" }).catch(() => null);
  if (head?.ok) return url;
  const { error } = await storage().upload(path, await makeBlob(), { contentType, upsert: true, cacheControl: "300" });
  if (error) throw error;
  return url;
}

export async function deleteMediaPath(path) {
  const { error } = await storage().remove([path]);
  if (error) throw error;
}

export function ownPathFromUrl(url, uid) {
  const marker = `/storage/v1/object/public/${MEDIA_BUCKET}/`;
  const idx = url?.indexOf(marker) ?? -1;
  if (idx < 0) return null;
  const path = decodeURIComponent(url.slice(idx + marker.length).split(/[?#]/)[0]);
  return path.startsWith(`${uid}/`) && !path.includes("..") ? path : null;
}

// Best effort: only ever deletes objects under the signed-in user's own prefix.
export async function deleteOwnMediaByUrl(url) {
  if (!url) return;
  const uid = await requireUserId();
  const path = ownPathFromUrl(url, uid);
  if (path) await deleteMediaPath(path).catch(() => {});
}
